export default {
  CHILD_DEVELOPMENT: "子女成长",
  EDU_AND_CAREERS: "升学及就业资讯",
  E_LEARNING: "电子学习及辅助学习工具",
  PARENT_CHILD: "亲子关係",
  PARENT_SCH: "家校沟通",
  READING: "阅读",
  SELF_LEARNING: "自主学习及奖励计划",
  SPECIAL: "特殊学习需要",
};
